import { useAtomValue } from 'jotai';
import { useEffect, useEffectEvent, useMemo } from 'react';
import { indexRowListedInstrumentsAtom, indexRowRefreshVersionAtom } from '../../state';
import { ListedInstrument } from '../../types';
import { isDefined, LoadableState } from '../../utils';
import { useListedInstrumentsByRicCommon } from '../instrument/useListedInstrumentsByRicCommon';

export type UseIndexRowListedInstrumentsCommonParams = {
  rics: string[];
  getListedInstrumentList: (ricList: string[]) => Promise<Array<ListedInstrument>>;
};

export type UseIndexRowListedInstrumentsCommonOutput = {
  indexRowInstruments: Record<string, LoadableState<ListedInstrument>>;
};

export const useIndexRowListedInstrumentsCommon = ({
  rics,
  getListedInstrumentList,
}: UseIndexRowListedInstrumentsCommonParams): UseIndexRowListedInstrumentsCommonOutput => {
  const refreshVersion = useAtomValue(indexRowRefreshVersionAtom);
  const { instrumentsByRic, reload } = useListedInstrumentsByRicCommon({
    rics,
    atom: indexRowListedInstrumentsAtom,
    getListedInstrumentList,
  });

  const reloadInEffect = useEffectEvent(reload);

  // Force reload when refresh version changes.
  useEffect(() => {
    if (isDefined(refreshVersion)) {
      reloadInEffect();
    }
  }, [refreshVersion]);

  return useMemo<UseIndexRowListedInstrumentsCommonOutput>(
    () => ({ indexRowInstruments: instrumentsByRic }),
    [instrumentsByRic],
  );
};
